import React from 'react';
import { RenderIf } from 'react-rainbow-components';
import { Close } from '@rainbow-modules/icons';
import { FullCloseButton, FullPageContainer, Header, HeaderContainer, FullPageIframe as StyledFullPageIframe, FullPageInnerContainer, StyledSpinner, } from './styled';
var FullPageIframe = function (_a) {
    var id = _a.id, className = _a.className, style = _a.style, src = _a.src, title = _a.title, header = _a.header, isOpen = _a.isOpen, isLoading = _a.isLoading, onRequestClose = _a.onRequestClose, onLoad = _a.onLoad;
    if (!isOpen)
        return null;
    return (React.createElement(FullPageContainer, { id: id },
        React.createElement(Header, null,
            React.createElement(HeaderContainer, null, header),
            React.createElement(FullCloseButton, { id: "modal-close-button", icon: React.createElement(Close, null), size: "x-small", onClick: onRequestClose })),
        React.createElement(FullPageInnerContainer, null,
            React.createElement(RenderIf, { isTrue: isLoading },
                React.createElement(StyledSpinner, { type: "arc", variant: "brand" })),
            React.createElement(StyledFullPageIframe, { className: className, style: style, src: src, title: title, isLoading: isLoading, onLoad: onLoad }))));
};
export default FullPageIframe;
//# sourceMappingURL=fullPage.js.map